module.exports = __webpack_public_path__ + "static/BigBang_Mega_clip-cae495726f1d37e58e50b5cd3c16902a.mp4";